<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_230_57015)">
      <path
        d="M3.54569 9.66899L2.98876 11.7481L0.953162 11.7912C0.344818 10.6628 -0.000244141 9.37186 -0.000244141 7.99999C-0.000244141 6.67339 0.322381 5.42239 0.894256 4.32086H0.894693L2.70694 4.65311L3.50082 6.45449C3.33466 6.93889 3.2441 7.45889 3.2441 7.99999C3.24416 8.58724 3.35054 9.14989 3.54569 9.66899Z"
        fill="#FBBB00"
      />
      <path
        d="M15.8599 6.50549C15.9518 6.98943 15.9997 7.48921 15.9997 7.99999C15.9997 8.57274 15.9394 9.13143 15.8247 9.67034C15.4353 11.5042 14.4177 13.1055 13.008 14.2387L13.0076 14.2382L10.725 14.1218L10.4019 12.1051C11.3373 11.5565 12.0683 10.698 12.4534 9.67034H8.17554V6.50549H12.5158H15.8599Z"
        fill="#518EF8"
      />
      <path
        d="M13.0076 14.2382L13.0081 14.2387C11.6371 15.3406 9.89553 16 7.99972 16C4.95312 16 2.30434 14.2971 0.953125 11.7912L3.54566 9.66901C4.22125 11.4721 5.96059 12.7556 7.99972 12.7556C8.87619 12.7556 9.69731 12.5187 10.4019 12.105L13.0076 14.2382Z"
        fill="#28B446"
      />
      <path
        d="M13.1062 1.84175L10.5145 3.9635C9.78529 3.50769 8.92329 3.24437 7.99979 3.24437C5.91451 3.24437 4.14263 4.58678 3.50088 6.4545L0.894725 4.32088H0.894287C2.22572 1.75384 4.90791 0 7.99979 0C9.94088 0 11.7207 0.691437 13.1062 1.84175Z"
        fill="#F14336"
      />
    </g>
    <defs>
      <clipPath id="clip0_230_57015">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(-0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
  
<script>
export default {
  name: "GoogleIcon",
};
</script>